import Bouncer from 'formbouncerjs';

export const initValidation = (form : Element) => {
  const windowMessages = window.errorMessages;
  const bouncer = new Bouncer(`#${form.id}`, {
    patterns: {
      email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]{2,}\.)+[a-zA-Z]{2,}))$/,
    },
    customValidations: {
      isFullName: function (field) {
        const fieldContainer = field.closest(".gfield.gfield--type-fullname-text");

        // Ignore validation if the field container does not exist.
        if(!fieldContainer) return false;

        // Check that the value has more than one word.
        const fieldValue = field.value;
        const wordCount = fieldValue.split(' ').filter(i => i); // Removes whitespace and empty strings.

        if(wordCount.length < 2) return true;

        return false;
      },
      isGeolocatedZipCode: function (field) {
        const fieldContainer = field.closest(".gfield.gfield--type-zip-to-market-text");

        // Ignore validation if the field container does not exist.
        if(!fieldContainer) return false;

        const zipInput = form.querySelector(`input[name="${field.name}_zip"]`);
        if(!zipInput) return true;

        // The hidden zip field is only set with geolocation. If this matches the text input value, then we are good to go.
        return field.value !== zipInput.value;
      }
    },
    disableSubmit: true,
    messages: {
      ...windowMessages || {},
      isFullName: 'This field requires at least 2 words.',
      isGeolocatedZipCode: 'You must select a valid location.',
    }
  });

  return bouncer;
}
